/**
 * bootstrap angular app
 * @param {ng.IModule}  ngModule
 * @param {string | Element | Document} [element=document]
 * @param {boolean} [strictDi=true]
 */
function bootstrap(ngModule, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.element, element = _c === void 0 ? document : _c, _d = _b.strictDi, strictDi = _d === void 0 ? true : _d;
    var appRoot = _getAppRoot(element);
    angular.element(document).ready(function () {
        angular.bootstrap(appRoot, [ngModule.name], {
            strictDi: true
        });
    });
}
exports.bootstrap = bootstrap;
function _getAppRoot(element) {
    if (typeof element === 'string') {
        return document.querySelector(element);
    }
    return element;
}
//# sourceMappingURL=browser.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/ng-metadata/src/platform/browser.js
 ** module id = 48
 ** module chunks = 0
 **/